import script from "./PlatformAdminLayoutMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformAdminLayoutMenu.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformAdminLayoutMenu.vue?vue&type=style&index=0&id=032111f1&lang=scss"

const __exports__ = script;

export default __exports__